import * as React from "react";
import { useState } from "react";
import * as ReactDOM from "react-dom";

import {
    Alert,
    Container,
    Paper,
    TextField,
    Button,
    Avatar,
    Typography,
    styled,
    InputAdornment,
    IconButton,
} from "@mui/material";
import { LockOutlined as LockOutlinedIcon, Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { useSettings, useStateReset } from "@Tmp/Hooks";
import { ThemeProvider } from "./components/ThemeProvider";

const ContainerStyled = styled(Container)(({ theme }) => ({
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(12),
}));

const PaperStyled = styled(Paper)(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(5),
}));

const AlertContainerStyled = styled("div")(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(1),
    marginTop: theme.spacing(4),
}));

const Login: React.FC = (props) => {
    const settings = useSettings();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [failed, setFailed] = useState(false);
    const [failedMessage, setFailedMessage, resetFailedMessage] =
        useStateReset("Something went wrong");
    const [successful, setSuccessful] = useState(false);

    const login = () => {
        setFailed(false);
        resetFailedMessage();
        axios
            .post("/wp-content/plugins/tmp/api/dealer/login.php", {
                email: email,
                password: password,
            })
            .then((response) => {
                if (response.status === 200) {
                    setSuccessful(true);
                    if (
                        "referrer" in document &&
                        document.referrer.replace(new RegExp(".*" + settings.domain), "") !== "/"
                    ) {
                        window.location.href = document.referrer;
                    } else {
                        window.location.href = "/dealer";
                    }
                } else {
                    setFailed(true);
                    if (response.data?.message) {
                        setFailedMessage(response.data?.message);
                    }
                }
            })
            .catch((error) => {
                setFailed(true);
                if (error.response.data?.message) {
                    setFailedMessage(error.response.data?.message);
                }
            });
    };

    const onKeyUp = (e) => {
        if (e.key === "Enter") {
            login();
        }
    };

    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <ContainerStyled maxWidth="sm">
            <PaperStyled elevation={3}>
                <TextField
                    required
                    fullWidth
                    value={email}
                    onChange={(e) => {
                        setEmail(e.target.value);
                    }}
                    onKeyUp={onKeyUp}
                    label="Email"
                    margin="normal"
                    variant="outlined"
                    autoComplete="email"
                />
                <TextField
                    required
                    fullWidth
                    value={password}
                    onChange={(e) => {
                        setPassword(e.target.value);
                    }}
                    onKeyUp={onKeyUp}
                    label="Kodeord"
                    margin="normal"
                    variant="outlined"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <Button
                    fullWidth
                    onClick={(e) => {
                        login();
                    }}
                    variant="contained"
                    color="primary"
                    sx={{
                        marginTop: (theme) => theme.spacing(3),
                    }}
                >
                    Log ind
                </Button>
                {failed && (
                    <AlertContainerStyled>
                        <Alert severity="error">Login failed - {failedMessage}</Alert>
                    </AlertContainerStyled>
                )}
                {successful && (
                    <AlertContainerStyled>
                        <Alert severity="success">
                            Login succeeded - if you did not get redirected, then{" "}
                            <a href="/dealer">Click here</a>
                        </Alert>
                    </AlertContainerStyled>
                )}
            </PaperStyled>
        </ContainerStyled>
    );
};

export default Login;

ReactDOM.render(
    <ThemeProvider>
        <Login />
    </ThemeProvider>,
    document.getElementById("root")
);
